import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import {
	BrandUtil,
	useContentfulPreview,
	EmotionBreakpoint,
	LoadingIcon,
} from 'dw-us-ui';
import MembershipPerks from '../components/MembershipPerks';
import ThreeBrothersCards from '../components/threeBrothersCards';
import BrothersDescription from '../components/BrothersDescription';
import CompareCards from '../components/compareCards';
import BrosFaqs from '../components/brosFaqs';
import { Helmet } from 'react-helmet';

const contentful = require(`contentful`);

const Container = styled.div`
	width: 100% !important;
	max-width: 100% !important;
	height: 100% !important;
	max-height: 100% !important;ss
`;
const Layout = styled.div`
	display: flex;
	width: 100%;
	max-width: 100%;
	padding: 60px 0px 0px 0px;
	flex-direction: column;
	align-items: center;
	gap: 60px;
	background: ${(props) =>
		props.backGroundColor ? props.backGroundColor : '#FAF3E6'};
	${EmotionBreakpoint('mobile')} {
		width: 100%;
		padding: 41px 15px;
		gap: 30px;
	}
	${EmotionBreakpoint('tablet')} {
	}
	${EmotionBreakpoint('notMobile')} {
	}
`;
const MainContainer = styled.div`
	display: flex;
	max-width: 689px;
	width: 100%;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	${EmotionBreakpoint('mobile')} {
	}
`;
const Title = styled.h1`
	color: ${(props) => (props.titleColor ? props.titleColor : '#00193c')};
	text-align: center;
	font-family: ${(props) => (props.titleFont ? props.titleFont : 'Open Sans')},
		sans-serif;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 22.4px;
	text-transform: uppercase;
	${EmotionBreakpoint('mobile')} {
	}
`;
const Headline = styled.h2`
	align-self: stretch;
	color: ${(props) => (props.headlineColor ? props.headlineColor : '#cf004f')};
	text-align: center;
	font-family: ${(props) =>
			props.headlineFont ? props.headlineFont : 'Oswald'},
		sans-serif;
	font-weight: normal;
	font-size: 48px;
	font-style: normal;
	font-weight: 500;
	line-height: 45.6px;
	letter-spacing: -0.48px;
	${EmotionBreakpoint('mobile')} {
		font-size: 34px;
		line-height: 35.7px;
	}
`;
const BodyCopy = styled.div`
	color: ${(props) => (props.bodyCopyColor ? props.bodyCopyColor : '#00193c')};
	align-self: stretch;
	text-align: center;
	font-family: ${(props) =>
			props.bodyCopyFont ? props.bodyCopyFont : 'Open Sans'},
		sans-serif;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 22.4px;

	${EmotionBreakpoint('mobile')} {
		align-self: stretch;
		color: #00193c;
		text-align: center;
		font-family: ${(props) =>
				props.bodyCopyFont ? props.bodyCopyFont : 'Open Sans'},
			sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 22.4px;
	}
`;
const CardsContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: flex-start;
	gap: 66px;
	max-width: 100%;
	width: 100%;
	background: ${(props) =>
		props.backGroundColor ? props.backGroundColor : '#FAF3E6'};
	padding: 70px 30px 90px 30px;
	${EmotionBreakpoint('tablet')} {
		display: flex;
		justify-content: normal;
		align-items: flex-start;
		gap: 56px;
		padding: 73px 29px 90px;
	}
	${EmotionBreakpoint('mobile')} {
		-webkit-box-pack: center;
		justify-content: flex-start;
		overflow-x: auto;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: none;
		&::-webkit-scrollbar {
			display: none;
		}
		gap: 57px;
		padding: 24px 30px 30px 30px;
	}
`;
const MembershipPerksContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	max-width: 100%;
	height: auto;
	${EmotionBreakpoint('mobile')} {
		padding-bottom: 44px;
		height: auto;
	}
`;
const BrothersDescriptionContainer = styled.div`
	background: ${(props) =>
		props.backGroundColor ? props.backGroundColor : '#FAF3E6'};
	max-width: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	${EmotionBreakpoint('mobile')} {
	}

	${EmotionBreakpoint('tablet')} {
	}
	${EmotionBreakpoint('notMobile')} {
	}
`;
const CompareCardsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 100px;
	padding-top: 100px;
	${EmotionBreakpoint('mobile')} {
		padding-top: 44px;
	}
`;
const FaqContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 100px;
	width: 100%;
`;

const HomePage = () => {
	const [isLoading, setLoading] = useState(true);
	const [contentfulData, setContentfulData] = useState();
	const brand = BrandUtil.getBrand();

	const brandTag = BrandUtil.content(brand).tag.toLowerCase();

	const { isPreview, sysId } = useContentfulPreview('hub_page_preview');

	let host, accessToken;

	if (isPreview) {
		accessToken = 'C4twFy9_lOdTcwrqh2yloRwl-TpH_VwcZE0sgiqVU1M';
		host = 'preview.contentful.com';
	} else {
		accessToken = 'wvjyW-zr51YWLmFHfHAyq8hYqwIQC2OuaJFuMl8xKrw';
		host = 'cdn.contentful.com';
	}

	const client = contentful.createClient({
		space: 'k1ni6e3k3b2n',
		accessToken,
		host: host,
		environment: 'master',
	});

	const resolveResponse = (response) => {
		setContentfulData(response.items[0].fields);
		setLoading(false);
	};

	const resolveError = (error) => {
		setLoading(false);
	};

	const additionalFilters = {
		'fields.brand': brandTag.toUpperCase(),
	};
	if (sysId?.length) {
		additionalFilters['sys.id'] = sysId;
	}

	const contentfulQuery = {
		content_type: 'threeBrothers',
		include: '4',
		...additionalFilters,
	};

	useEffect(() => {
		setLoading(true);

		client
			.getEntries(contentfulQuery)
			.then((entriesResponse) => resolveResponse(entriesResponse))
			.catch((entriesError) => resolveError(entriesError));
	}, []);

	if (isLoading) {
		return <LoadingIcon />;
	}

	return (
		<Container>
			<Layout
				id='layoutColor'
				backGroundColor={contentfulData?.backGroundColor}
			>
				<MainContainer>
					{contentfulData && (
						<>
							<Helmet>
								{contentfulData.seoMeta?.fields?.seoTitle ? (
									<title> {contentfulData.seoMeta?.fields?.seoTitle} </title>
								) : (
									''
								)}
								{contentfulData.seoMeta?.fields?.description ? (
									<meta
										name='description'
										content={contentfulData.seoMeta?.fields?.description}
									/>
								) : (
									''
								)}
								{contentfulData.seoMeta?.fields?.keywords ? (
									<meta
										name='keywords'
										content={contentfulData.seoMeta?.fields?.keywords}
									/>
								) : (
									''
								)}
							</Helmet>
							<Title
								titleColor={contentfulData?.titleColor}
								titleFont={contentfulData?.titleFont}
							>
								{contentfulData?.title}
							</Title>
							<Headline
								headlineColor={contentfulData?.headlineColor}
								headlineFont={contentfulData?.headlineFont}
							>
								{contentfulData?.textHeadline?.content[0]?.content[0]?.value}
							</Headline>
							<BodyCopy
								id='bodyCopy'
								bodyCopyColor={contentfulData?.bodyCopyColor}
								bodyCopyFont={contentfulData?.bodyCopyFont}
							>
								{contentfulData?.textDescription}
							</BodyCopy>
						</>
					)}
				</MainContainer>
			</Layout>

			<CardsContainer
				id='CardsContainer'
				backGroundColor={contentfulData?.backGroundColor}
			>
				{contentfulData &&
					contentfulData?.threeBrothersCards?.map((card, index) => (
						<ThreeBrothersCards
							key={index}
							card={card}
							contentfulData={contentfulData}
						/>
					))}
			</CardsContainer>

			<MembershipPerksContainer>
				<MembershipPerks contentfulData={contentfulData} />
			</MembershipPerksContainer>

			<BrothersDescriptionContainer
				id='brothersDescriptionContainer'
				backGroundColor={contentfulData?.backGroundColor}
			>
				<BrothersDescription contentfulData={contentfulData} />
			</BrothersDescriptionContainer>

			<CompareCardsContainer>
				<CompareCards contentfulData={contentfulData} />
			</CompareCardsContainer>

			<FaqContainer>
				<BrosFaqs contentfulData={contentfulData} />
			</FaqContainer>
		</Container>
	);
};

export default HomePage;
